<div kalDialogContent
     [kalLoading]="loading">

    <kal-table
        [columns]="columns"
        [dataSource]="tableDataSource"
        class="no-action">

        <tr *kalHeaderRowDef kal-header-row></tr>

    </kal-table>

</div>

<div kalDialogFooter>
    <div class="gup-C-validationArea gup-O-list">
        <div class="gup-O-list__item">
            <kal-button kalTheme="primary"
                        (click)="close()">
                Fermer
            </kal-button>
        </div>
        <div class="gup-O-list__item">
            <kal-button kalTheme="secondary"
                        (click)="export()">
                Exporter les données
            </kal-button>
        </div>
    </div>
</div>
